import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { AvantI18nProvider } from '../components/providers'
import RenderComponent from '../renderer'

export class RenderProvider extends React.Component{
  constructor(props, context){
    super(props, context)
  }
  getChildContext(){
    return {
      components: this.props.components,
      selectors:  this.props.selectors,
      actions:    this.props.actions
    }
  }
  render(){
    return React.Children.only(this.props.children)
  }
}

RenderProvider.childContextTypes = {
  components: React.PropTypes.object.isRequired,
  selectors: React.PropTypes.object.isRequired,
  actions: React.PropTypes.object.isRequired
}

export const ApplicationContainer = (props) => {
  const {
     components, selectors, actions, layout, store, t
  } = props
  return(
    <div>
      <Provider store={store}>
        <AvantI18nProvider t={t}>
          <RenderProvider components={components} selectors={selectors} actions={actions}>
            <RenderComponent layout={layout} />
          </RenderProvider>
        </AvantI18nProvider>
      </Provider>
    </div>
  )
}
